module.exports = __webpack_public_path__ + "tables/media/Settings_filled.59f836ba.svg";